<template>
  <div>
    <iframe class="fullscreen" :src="iframeUrl"></iframe>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        iframeUrl: 'https://ai-gen-dentures.aidlux.com'
      };
    }
  };
</script>

<style>
  iframe.fullscreen{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: none;
      margin: 0;
      padding: 0;
      overflow: hidden;
      z-index: 9999;
  }
</style>



// WEBPACK FOOTER //
// index.vue?2e66a8cc